import {
  AE_SET_LOADING,
  AE_SET_ERROR,
  AE_SET_ADMIN_EMPLOYERS,
  AE_ADD_ADMIN_EMPLOYER,
  AE_UPDATE_ADMIN_EMPLOYER,
  AE_REMOVE_ADMIN_EMPLOYER,
  AE_SET_BOARD_EMPLOYERS,
  AE_ADD_BOARD_EMPLOYER,
  AE_REMOVE_BOARD_EMPLOYER,
  AE_SET_AVAILABLE_EMPLOYERS,
  AE_SET_EXECUTIONS,
  AE_ADD_EXECUTION,
  AE_UPDATE_EXECUTION,
  AE_SET_QUESTIONS,
  AE_ADD_QUESTION,
  AE_UPDATE_QUESTION,
  AE_REMOVE_QUESTION,
  AE_SET_BOARD_PENDING_QUESTIONS,
  AE_RESET,
} from "./aiEmployerTypes";

const initialState = {
  loading: false,
  error: null,

  /** Admin-side: global employers list */
  employers: [],

  /** Board-side: employers imported to current board */
  boardEmployers: [],
  /** Board-side: employers available for import (not yet on board) */
  availableEmployers: [],

  /** Task executions */
  executions: [],

  /** Human-in-loop questions (for currently viewed task or board) */
  questions: [],
  /** Pending board-level questions (aggregated) */
  boardPendingQuestions: [],
};

export const aiEmployerReducer = (state = initialState, action) => {
  switch (action.type) {
    case AE_SET_LOADING:
      return { ...state, loading: action.payload, error: null };
    case AE_SET_ERROR:
      return { ...state, error: action.payload, loading: false };

    case AE_SET_ADMIN_EMPLOYERS:
      return { ...state, employers: action.payload };
    case AE_ADD_ADMIN_EMPLOYER:
      return { ...state, employers: [action.payload, ...state.employers] };
    case AE_UPDATE_ADMIN_EMPLOYER:
      return {
        ...state,
        employers: state.employers.map((e) =>
          e._id === action.payload._id ? { ...e, ...action.payload } : e
        ),
      };
    case AE_REMOVE_ADMIN_EMPLOYER:
      return {
        ...state,
        employers: state.employers.filter((e) => e._id !== action.payload),
      };

    case AE_SET_BOARD_EMPLOYERS:
      return { ...state, boardEmployers: action.payload };
    case AE_ADD_BOARD_EMPLOYER:
      return {
        ...state,
        boardEmployers: [action.payload, ...state.boardEmployers],
      };
    case AE_REMOVE_BOARD_EMPLOYER:
      return {
        ...state,
        boardEmployers: state.boardEmployers.filter(
          (e) => e.assignmentId !== action.payload && e.employerId !== action.payload
        ),
      };
    case AE_SET_AVAILABLE_EMPLOYERS:
      return { ...state, availableEmployers: action.payload };

    case AE_SET_EXECUTIONS:
      return { ...state, executions: action.payload };
    case AE_ADD_EXECUTION:
      return { ...state, executions: [action.payload, ...state.executions] };
    case AE_UPDATE_EXECUTION: {
      const idx = state.executions.findIndex((ex) => ex._id === action.payload._id);
      if (idx >= 0) {
        const updated = state.executions.map((ex, i) =>
          i === idx ? { ...ex, ...action.payload } : ex
        );
        return { ...state, executions: updated };
      }
      // Upsert — add if not found
      return { ...state, executions: [action.payload, ...state.executions] };
    }

    case AE_SET_QUESTIONS:
      return { ...state, questions: action.payload };
    case AE_ADD_QUESTION:
      return { ...state, questions: [action.payload, ...state.questions] };
    case AE_UPDATE_QUESTION:
      return {
        ...state,
        questions: state.questions.map((q) =>
          q._id === action.payload._id ? { ...q, ...action.payload } : q
        ),
      };
    case AE_REMOVE_QUESTION:
      return {
        ...state,
        questions: state.questions.filter((q) => q._id !== action.payload),
      };
    case AE_SET_BOARD_PENDING_QUESTIONS:
      return { ...state, boardPendingQuestions: action.payload };

    case AE_RESET:
      return initialState;

    default:
      return state;
  }
};
